import script from "./InspecaoSupervisaoEstabelecimentoFinalizacaoB.vue?vue&type=script&setup=true&lang=js"
export * from "./InspecaoSupervisaoEstabelecimentoFinalizacaoB.vue?vue&type=script&setup=true&lang=js"

import "./InspecaoSupervisaoEstabelecimentoFinalizacaoB.vue?vue&type=style&index=0&id=03497aea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03497aea"]])

export default __exports__